import { Helmet } from 'react-helmet';

export default function ContentlyHelmet() {
  return(
      <Helmet>
        <title>Contently</title>
        <link rel="icon" href="/favicon.ico" />
        <meta name="description" content="Contently platform" />
      </Helmet>
  );
};

